import moment from "moment";

export const createShortName = (name, lastName) => {
  let shortName = name.length > 0 ? name[0].toUpperCase() : "";
  shortName =
    lastName.length > 0 ? shortName + lastName[0].toUpperCase() : shortName;
  return shortName;
};

export const createFullName = (name, lastName) => {
  const fullName =
    name.trim().toUpperCase() + " " + lastName.trim().toUpperCase();
  return fullName;
};

export const getToday = () => {
  return moment().format("YYYY-MM-DD");
};

export const monthNumberToName = (monthN, camelCase = false) => {
  let month = "";
  if (monthN.length < 2) {
    monthN = "0" + monthN;
  }
  switch (monthN.toString()) {
    case "01":
      month = "ENERO";
      break;
    case "02":
      month = "FEBRERO";
      break;
    case "03":
      month = "MARZO";
      break;
    case "04":
      month = "ABRIL";
      break;
    case "05":
      month = "MAYO";
      break;
    case "06":
      month = "JUNIO";
      break;
    case "07":
      month = "JULIO";
      break;
    case "08":
      month = "AGOSTO";
      break;
    case "09":
      month = "SEPTIEMBRE";
      break;
    case "10":
      month = "OCTUBRE";
      break;
    case "11":
      month = "NOVIEMBRE";
      break;
    case "12":
      month = "DICIEMBRE";
      break;
  }
  if (camelCase) {
    month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
  }
  return month;
};

export const dayNumberToName = (dayN, camelCase = false, plural = false) => {
  let day = "";
  switch (dayN.toString()) {
    case "1":
      day = "LUNES";
      break;
    case "2":
      day = "MARTES";
      break;
    case "3":
      day = "MIERCOLES";
      break;
    case "4":
      day = "JUEVES";
      break;
    case "5":
      day = "VIERNES";
      break;
    case "6":
      day = plural ? "SABADOS" : "SABADO";
      break;
    case "7":
      day = plural ? "DOMINGOS" : "DOMINGO";
      break;
  }
  if (camelCase) {
    day = day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
  }
  return day;
};

export const hourNumberToTime = (number) => {
  let hourS = parseInt(number);
  if (number < 10) {
    hourS = "0" + hourS;
  }
  return hourS.toString();
};

export const copyObject = (object) => {
  return JSON.parse(JSON.stringify(object));
};

export const formatCurrency = (value) => {
  const valueV = formatNumber(value) + " €";

  if (valueV === "-0,00 €") {
    return "0,00 €";
  }

  return valueV;
};

export const formatNumber = (value) => {
  const formatter = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const valueV = formatter.format(value);

  return valueV === "-0,00" ? "0,00" : valueV;
};

export const formatFloatFromCurrency = (value) => {
  const cleanedValue = value
    .replace(/\./g, "")
    .replace(",", ".")
    .replace(/[^\d.-]/g, "");

  const floatValue = parseFloat(cleanedValue);

  return floatValue;
};

export const createAddress = (address, city, province, pc) => {
  const fullAddress = [address, city, province, pc]
    .filter((elemento) => elemento !== "")
    .join(", ")
    .toUpperCase();
  return fullAddress;
};

export const calculatePVU = (pvp, dto) => {
  let v = pvp - pvp * (dto / 100);
  if (v < 0) {
    v = 0;
  }
  return v;
};

export const calculateDto = (pvp, pvu) => {
  const dto = pvp == 0 ? 0 : ((pvp - pvu) * 100) / pvp;
  return dto;
};

export const calculateIVASuperRed = (pvp, dto, uds, IVASuperRed) => {
  const newPVP = pvp * (1 + IVASuperRed / 100);
  const pvu = calculatePVU(newPVP, dto);
  const result = {
    pvp: Math.round(newPVP, 2),
    pvu: Math.round(pvu, 2),
    total: Math.round(pvu * uds, 2),
  };
  return result;
};

export const getFamilyFromOPTIWINCode = (code) => {
  return parseInt(code[0]);
};

export const calculateDtoFromAll = (
  pvp,
  patDto,
  pvpOffer,
  offerFrom,
  offerTo,
  pvpSpecial,
  specialUds,
  uds,
  dtoMax,
  createPopupQuestion,
  removePopupQuestion
) => {
  const today = moment().format("YYYY-MM-DD");

  const dtoO =
    offerFrom <= today && offerTo >= today && pvpOffer !== ""
      ? Math.round(((pvp - pvpOffer) / pvp) * 100)
      : 0;

  const dtoS =
    uds >= specialUds && pvpSpecial !== ""
      ? Math.round(((pvp - pvpSpecial) / pvp) * 100)
      : 0;

  let dtoP = 0;
  if (dtoMax !== "" && patDto > dtoMax && dtoO === 0 && dtoS === 0) {
    // No está de oferta y tiene descuento máximo

    createPopupQuestion(
      "El descuento del paciente (" +
        patDto +
        "%) es mayor que el máximo permitido para este producto (" +
        dtoMax +
        "%). No se puede aplicar descuento.",
      removePopupQuestion,
      null,
      "Cerrar"
    );
  } else {
    dtoP = patDto === "" ? 0 : patDto;
  }

  const dto = Math.max(dtoP, dtoO, dtoS);
  let pvu = pvp;
  if (dto === dtoP) {
    pvu = calculatePVU(pvp, dto);
  } else if (dto === dtoO) {
    pvu = pvpOffer;
  } else if (dto === dtoS) {
    pvu = pvpSpecial;
  }

  return {
    dto,
    pvu,
  };
};
